<template>
  
  <div class="extension_time__form" id="pdf"  >
    <!--PRINT HEADER-->
<div
      class="d-flex flex-column align-center to-show"
      style="gap: 14px; display: none; visibility: hidden; height: 0px"
    >
      <div class="d-flex align-center">
        <v-img
          :src="require('@/assets/Logo2.png')"
          width="146"
          height="48"
          aspect-ratio="1"
        ></v-img>
      </div>

      <div class="d-flex align-center">
        <div class="page-title">แบบฟอร์มข้อเสนอโครงการ</div>
      </div>
      <div class="d-flex align-center">
        <div class="txt-head">โดยอุทยานวิทยาศาสตร์ {{ user?.region ?? "" }}</div>
      </div>
    </div>

    <h1 >ยื่นขอขยายเวลา</h1>
    <v-layout class="d-flex align-center mt-6">
      <v-flex shrink :class="printing ? '' : 'mr-3'">
        <v-img  class="to-hide"
          :src="
            require('../../../../assets/images/extension-time/calendar-add.png')
          "
          width="20"
          height="20"
        ></v-img>
      </v-flex>
      <v-flex shrink>
        <div class="font-20 font-w-600">รายละเอียดการขอขยายเวลา</div>
      </v-flex>
    </v-layout>

    <div class="custom_card mt-4">
      <v-layout wrap>
        <v-flex lg2 md3 class="font-14 font-w-600 mb-2">แผนงาน</v-flex>
        <v-flex lg10 md9>
          <div class="font-14 mb-2">
            {{ form.plan_name ? form.plan_name : "- ไม่มีข้อมูล -" }}
          </div>
        </v-flex>
        <v-flex lg2 md3 class="font-14 font-w-600">ชื่อโครงการ(ไทย)</v-flex>
        <v-flex lg10 md9>
          <div class="font-14">
            {{ form.project_name ? form.project_name : "- ไม่มีข้อมูล -" }}
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="custom_card mt-4">
      <div class="font-20 font-w-700">แผนการดำเนินงาน</div>

      <v-layout class="mt-5">
        <v-flex xs2>
          <div class="font-14 font-w-600 mb-2">
            ครั้งที่ <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          {{ form.round ? form.round : "- ไม่มีข้อมูล -" }}
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs2>
          <div class="font-14 font-w-600 mb-3">
            ระยะเวลาที่ขยายเวลา (เดือน) <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          {{ form.duration ? form.duration : "- ไม่มีข้อมูล -" }}
          เดือน
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs2>
          <div class="font-14 font-w-600 mb-3">
            ขยายเวลาถึงวันที่ <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          {{ form.end_date ? toDateFormat(form.end_date) : "- ไม่มีข้อมูล -" }}
        </v-flex>
      </v-layout>

      <v-layout class="mb-3">
        <v-flex xs2>
          <div class="font-14 font-w-600">
            เหตุผล <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          <div class="font-14">
            {{ form.reason ? form.reason : "- ไม่มีข้อมูล -" }}
          </div>
        </v-flex>
      </v-layout>

      <div class="font-14 font-w-700 mb-2">เอกสารเเนบ</div>

      <v-layout
        align-center
        class="mt-3"
        v-for="(file, f) in form.files"
        :key="f" to-hide
      >
        <v-flex shrink >
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#F15A29"
            @click="downloadFile(file)"
          >
            <Iconify
              style="color: #fff"
              icon="system-uicons:download"
            ></Iconify>
            <span class="font-12 font-w-700">ดาวน์โหลด</span>
          </v-btn>
        </v-flex>
        <v-flex shrink ml-3>
          {{ file.file_name }}
        </v-flex>
      </v-layout>
    </div>

    <v-layout justify-space-between mt-6 class="to-hide">
      <v-flex shrink>
        <v-btn
            rounded
            depressed
            color="#D9D9D9"
            @click="$router.push('/usp/extend-time')"
        >
          <span style="color: #464647">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn @click.native="print()" color="#e51610" outlined rounded depressed>
          <Iconify
              style="color: #e51610"
              icon="fluent:document-pdf-24-filled"
          ></Iconify>
          <span style="color: #e51610">Export PDF </span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- <pre>
      {{ form }}
    </pre> -->
  </div>
</template>

<script>
import DatePicker from "../../../../components/input/DatePicker.vue";
import SERVICES from "../../../../services";

import {
  toDateFormat,
  toDateTimeFormat,
  formatNumber,
} from "@/plugins/global-funcs";
import axios from "axios";
export default {
  components: { DatePicker },
  data() {
    return {
      toDateFormat,
      form: {
        plan_name: "",
        project_name: "",
        //
        round: "",
        duration: "",
        start_date: "",
        end_date: "",
        reason: "",
        status: "",
        files: [],
      },
      printing: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const data = await this.$apiFire(
          "USPExtend/show",
          this.$route.params.id
        );
        this.form = data;
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.file_name);
        document.body.appendChild(link);
        link.click();
      })
          .catch((error) => {
            this.$store.commit('General/setModal', {
              title: 'ระบบไม่พบไฟล์ที่ร้องขอ',
              theme: 'warning',
              text: 'กรุณาติดต่อเจ้าหน้าที่',
              showCancel: false,
              buttonText: 'ตกลง'
            })
          });
    },
    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

      //change document title
      document.title =
          "Pending_"+
          today;
      let toHide = document.getElementsByClassName("to-hide");
      let pdfPage = document.getElementById("pdf");
      let mainContent = document.getElementById("main");
      let toShow = document.getElementsByClassName("to-show");


      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
.extension_time__form {
  .custom_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 15px 25px;
  }
}

@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;

}

</style>
